import List from '@utils/list'
import { Select } from '@utils/index'
import { Options } from '@utils/index'

const { Search, Jurisdiction, Table } = List

// const select = Select.copy('/purchaseUnit/getPurchaseUnitPage').params({ usingFlag: '1' })

const option = new Options('deliverysupplier.checkreturn')
  .add('1', 'orderTypeOption[0]')
  .add('2', 'orderTypeOption[1]')
  .add('3', 'orderTypeOption[2]')

const search = new Search('deliverysupplier.checkreturn')
  .placeholder('deliverysupplier.acceptancedetails.searchPlaceholder')
  .add('orderType').op(option)
  .lib('dateRange').prop(['purCheckReceiptDateStart', 'purCheckReceiptDateEnd']).label('docDate').br()
  .add('goodsNo')
  .add('goodsName')
  .add('spec')
  .add('purchaseUnitNo').label('purchaseUnitName')
  .select(Select.use('/purchaseUnit/getPurchaseUnitPage').params({ usingFlag: '1' }))
const jurisdiction = new Jurisdiction('deliverysupplier.checkreturn')
// .add('manual').icon('icon-shoudonghuoqu').sort(10)
// .add('import').icon('icon-daoru').sort(20)

const table = new Table('deliverysupplier.checkreturn')
  .type('index')
  .add('purCheckReceiptNo').label('deliverysupplier.acceptancedetails.inspectNo').sort(true)
  .add('purCheckReceiptDate').label('deliverysupplier.acceptancedetails.docDate').date('yyyy-MM-dd').sort(true)
  .add('orderType').op(option).sort(false)
  .add('purchaseUnitName')
  .add('inspectSeq').label('deliverysupplier.acceptancedetails.inspectSeq').html(({ row }) => `${row.purchaseSeq}-${row.purchasePhaseSeq}-${row.purchaseBatchSeq}`).sort(false)
  .add('goodsNo').sort(false)
  .add('goodsName').sort(false)
  .add('spec').sort(false)
  .add('purCheckReceiptQty').label('deliverysupplier.acceptancedetails.acceptQty').sort(false)
  .add('unitName').label('purUnitName').sort(false).sort(false).format(data => `${data.row.unitNo}-${data.row.unitName}`).width(80)
  .add('purchaseNo').sort(false)

export default new List()
  .url('/srmPurCheck/getPurCheckReceiptBody', process.env.VUE_APP_PURCHASE_API)
  .jurisdiction(jurisdiction)
  .search(search)
  .table(table)
  .end()
